import { MaterializationType, ModelListItemFragment } from "@/apollo/types";

type Model = ModelListItemFragment;

export function isDraftModel(model: Pick<Model, "publishedQueryId">) {
  return model.publishedQueryId == null;
}

export function isPendingTable(
  model: Pick<Model, "materializationType" | "publishedQueryId" | "dwTable">,
) {
  return (
    model.materializationType === MaterializationType.Table &&
    !isDraftModel(model) &&
    !model.dwTable?.latestSyncTime
  );
}
